import { render, staticRenderFns } from "./Shopware.vue?vue&type=template&id=6e915030&"
import script from "./Shopware.vue?vue&type=script&lang=js&"
export * from "./Shopware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports